<button class="checkout-upsell-container" (click)="addToOrder()">
    <div class="image-container">
        @if (imageUrl && itemImg()?.name !== "none") {
            <img class="image" [src]="imageUrl" [alt]="panelItem.label" (error)="onImgError($event)" />
        } @else if (itemImg()?.name === "none") {} @else {
            <img class="image-placeholder" [src]="'assets/icons/itemPlaceholder.svg'" [alt]="panelItem.label"  (error)="onImgError($event)"/>
        }
        <div class="add-container" aria-hidden="true">
            <div class="add">
                <cwo-icon class="icon" [name]="iconNameType.boldPlus" />
            </div>
        </div>
    </div>
    <span [attr.aria-hidden]="true" class="name">{{panelItem.label}}</span>
    @if (hasCalories()) {<span class="calories">{{hasCalories()}}</span>}
    <span class="price">{{selectedSizePrice.price | currency:'USD':'symbol'}}</span>
</button>